// Notification types
export const NOTIFICATION_TYPES = {
  GENERAL: 'general',
  INVITATION: 'invitation',
  MEETING: 'meeting'
};

// Notification status
export const NOTIFICATION_STATUS = {
  SENT: 'sent',
  DRAFT: 'draft'
};

// Response types
export const RESPONSE_TYPES = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  TENTATIVE: 'tentative',
  PENDING: 'pending'
};

// Response labels and colors
export const RESPONSE_CONFIG = {
  [RESPONSE_TYPES.ACCEPT]: {
    label: 'Accept',
    color: 'bg-success-subtle text-success',
    buttonColor: 'btn-success'
  },
  [RESPONSE_TYPES.REJECT]: {
    label: 'Reject', 
    color: 'bg-error-subtle text-error',
    buttonColor: 'btn-error'
  },
  [RESPONSE_TYPES.TENTATIVE]: {
    label: 'Tentative',
    color: 'bg-warning-subtle text-warning',
    buttonColor: 'btn-warning'
  },
  [RESPONSE_TYPES.PENDING]: {
    label: 'Pending',
    color: 'bg-info-subtle text-info',
    buttonColor: 'btn-outline'
  }
};

// Notification type labels
export const NOTIFICATION_TYPE_LABELS = {
  [NOTIFICATION_TYPES.GENERAL]: 'General Notification',
  [NOTIFICATION_TYPES.INVITATION]: 'Event Invitation',
  [NOTIFICATION_TYPES.MEETING]: 'Meeting Notice'
};

// File upload constraints
export const FILE_UPLOAD_CONFIG = {
  maxSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: [
    'image/jpeg', 'image/png', 'image/gif',
    'application/pdf',
    'application/vnd.ms-excel', 
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],
  maxFiles: 5
};

// Default notification data structure
export const DEFAULT_NOTIFICATION = {
  type: NOTIFICATION_TYPES.GENERAL,
  title: '',
  content: '',
  recipientIds: [],
  committeeIds: [],
  attachments: [],
  venue: '',
  eventDate: '',
  eventTime: '',
  meetingHeading: '',
  chairedBy: '',
  description: '',
  senderId: null,
  status: NOTIFICATION_STATUS.DRAFT,
  createdAt: null,
  sentAt: null
};